import { put, select } from "redux-saga/effects";
import { Buffer } from "buffer";
import importer from "common/importer";
const LoyalDonorActions = importer("Stores/Loyalty/Actions");
const { getLoyaltyContants } = importer("APIs/loyalty", null);
const { tokens } = importer("Stores/Users/Select", null);
export default function* main() {

  try {
    yield put(LoyalDonorActions.getLoyaltyConstantLoading());
    const res = yield getLoyaltyContants();
    const decodedResponse=Buffer.from(res.data,'base64')
    const JsonParsedRes= JSON.parse(decodedResponse)
    yield put(LoyalDonorActions.getLoyaltyConstantSuccess(JsonParsedRes));
  } catch (error) {
    yield put(LoyalDonorActions.getLoyaltyConstantFailure(error));
  }
}